<template>
  <div class="teacher-detail-item">
    <h2 class="title-wrapper">
      <template v-for="(title, index) in detail.title">
        <span :key="title + index" class="title">
          {{ title }}
        </span>
      </template>
    </h2>
    <div v-if="detail.content" class="desc" v-html="detail.content" />
    <div v-if="detail.images && detail.images.length > 0" class="image-box">
      <van-swipe
        indicator-color="white"
        :autoplay="5000"
      >
        <template v-for="(src, index) in detail.images">
          <van-swipe-item :key="index">
            <img :src="src" alt="">
          </van-swipe-item>
        </template>
      </van-swipe>

    </div>
    <basis-video-player
      v-if="detail.video"
      v-model="videoPlayer"
      class="video-player"
      :item="detail"
      :cover-options="{
        aspectRatio: '16:9',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      }"
      @playerReadied="onPlayerReadied"
    />
  </div>
</template>

<script>
import { BasisVideoPlayer } from '@/components/basis'

export default {
  name: 'TeacherDetailItem',
  components: { BasisVideoPlayer },
  props: {
    detail: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    videoPlayer: undefined
  }),
  methods: {
    // player is ready
    onPlayerReadied (player) {
      // seek to 10s
      player.currentTime(10)
    }
  }
}
</script>

<style scoped lang="scss">
.teacher-detail-item {
  padding-bottom: 50px;
  .title-wrapper {
    text-align: center;
    margin-bottom: 18px;
    &::after {
      @include wh(20px, 2px);
      content: " ";
      display: block;
      border-radius: 4px;
      background-color: #fd4444;
      margin: auto;
    }
    .title {
      @include wh(36px, 41px);
      @include sc($font-size-lg, #fff);
      @include lw(30px, 700);
      @include bg-image-png('/teacher/title');
      @include bg-image-fit;
      display: inline-block;
      font-family: 'SimSun', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
  }
  .desc {
    @include wh(100%, initial);
    @include sc($font-size-base, $color-text-medium);
    @include lw(16px, 400);
    text-align: justify;
    white-space: break-spaces;
    padding: 18px;
    border: 4px solid #fff;
    border-radius: 4px;
    margin-bottom: 18px;
    box-shadow:0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    background-color: #F8F9FF;
  }
  .image-box {
    margin-bottom: 18px;
    img {
      @include wh(100%, initial);
      display: block;
      & + img {
        margin-top: 6px;
      }
    }
  }
}
</style>
